import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface ChevronDownIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function ChevronDownIcon({ className, ...props }: ChevronDownIconProps) {
  return (
    <svg
      viewBox="0 0 12.5 7.14286"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('w-5 h-auto', className)}
      {...props}
    >
      <path transform="translate(0 7.14286) scale(1 -1)" d="M6.25 4.97532e-09L12.2779 5.87991C12.5812 6.17584 12.5728 6.66166 12.2592 6.94711C11.9667 7.21346 11.5139 7.20726 11.2289 6.93301L6.25 2.14104L1.27107 6.93301C0.986113 7.20726 0.533331 7.21346 0.240773 6.94711C-0.0727584 6.66166 -0.0812446 6.17584 0.222131 5.87991L6.25 4.97532e-09Z" fill="currentColor" />
    </svg>
  );
}
